import { Inline, useCollapse } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useBrandsImport } from 'hooks'
import { LIMITS } from 'shared'
import { Item } from 'typings'
import { BrandsSelector } from 'ui'
import { CollapsibleRule } from '../CollapsibleRule'
import { SelectorComponentProps } from '../constants'
import { OperatorSelector } from '../OperatorSelector'

export function BrandsScopeSelector(props: SelectorComponentProps) {
  const { name, form, open } = props

  const items: Item[] = useWatch({ form, name: `${name}.items` })

  const collapsibleState = useCollapse({ visible: open })

  const { importBrands, loading } = useBrandsImport()

  return (
    <CollapsibleRule state={collapsibleState}>
      <CollapsibleRule.Header
        state={collapsibleState}
        onRemove={() => form.setValue(name, undefined)}
      >
        <CollapsibleRule.Title state={collapsibleState} count={items.length}>
          <BrandsSelector.Header />
        </CollapsibleRule.Title>
      </CollapsibleRule.Header>
      <CollapsibleRule.Content
        state={collapsibleState}
        focusId={`${name}.items`}
      >
        <BrandsSelector>
          <CollapsibleRule.Actions>
            <OperatorSelector name={`${name}.operator`} form={form} />
            <Inline>
              <BrandsSelector.Download values={items} />
              <BrandsSelector.Upload
                name={`${name}.items`}
                form={form}
                importer={importBrands}
                maxEntries={LIMITS.MAX_BRANDS}
              />
            </Inline>
          </CollapsibleRule.Actions>
          <BrandsSelector.Selector
            name={`${name}.items`}
            state={form}
            loading={loading}
          />
        </BrandsSelector>
      </CollapsibleRule.Content>
    </CollapsibleRule>
  )
}
